import { render, staticRenderFns } from "./Section_Form.vue?vue&type=template&id=47ea6b54&scoped=true&"
import script from "./Section_Form.vue?vue&type=script&lang=js&"
export * from "./Section_Form.vue?vue&type=script&lang=js&"
import style0 from "./Section_Form.vue?vue&type=style&index=0&id=47ea6b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea6b54",
  null
  
)

export default component.exports